import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, BookOpenIcon, BarChart3Icon, ClipboardListIcon, CalculatorIcon, VideoIcon, HelpCircleIcon, ArrowUpRightIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { CTASection } from '../components/CTASection';
import { DemoModal } from '../components/DemoModal';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { resourceItems } from '../data/resources';
const iconMap = {
  file: FileTextIcon,
  book: BookOpenIcon,
  chart: BarChart3Icon,
  clipboard: ClipboardListIcon,
  calculator: CalculatorIcon,
  video: VideoIcon,
  help: HelpCircleIcon
};
export function ResourcesPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  return <motion.main initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.4
  }} className="min-h-screen w-full bg-stark-white overflow-x-hidden" data-id="element-371" data-mp="3rk4lxewi4cd6">
      <Header onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-372" data-mp="21sv46nra85sb" />

      <PageHero eyebrow="Resources" title="Thought leadership for operators who run the numbers." description="Articles, whitepapers, case studies, templates, calculators, and video walkthroughs from 27+ years in the field." data-id="element-373" data-mp="1xqrp7p5emj2a" />

      <section className="py-24 md:py-32" data-id="element-374" data-mp="2kpnwagopr0l2">
        <div className="max-w-7xl mx-auto px-6" data-id="element-375" data-mp="2kocuuniqq4x4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-376" data-mp="2gokidzq87emh">
            {resourceItems.map((resource, idx) => {
            const Icon = iconMap[resource.icon as keyof typeof iconMap];
            return <motion.article key={resource.title} initial={{
              opacity: 0,
              y: 24
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: idx * 0.05,
              ease: 'easeOut'
            }} whileHover={{
              y: -6
            }} className="group p-8 bg-stark-white border border-midnight-navy/10 rounded-2xl hover:border-royal-blue/40 hover:shadow-xl hover:shadow-midnight-navy/5 transition-all cursor-pointer" data-id="element-377" data-mp="2phxl1te3dulr" data-mpi={idx}>
                  <div className="flex items-start justify-between mb-8" data-id="element-378" data-mp="3u9nvultzv7rg">
                    <div className="w-12 h-12 rounded-2xl bg-cool-gray text-royal-blue flex items-center justify-center group-hover:bg-royal-blue group-hover:text-stark-white transition-colors" data-id="element-379" data-mp="31ta8mwap9sj">
                      <Icon className="w-6 h-6" data-id="element-380" data-mp="24u7ptfbda25s" />
                    </div>
                    <span className="text-[10px] font-bold uppercase tracking-widest text-royal-blue" data-id="element-381" data-mp="29qy8maek3buw">
                      {resource.type}
                    </span>
                  </div>
                  <h2 className="text-midnight-navy text-xl font-montserrat font-bold mb-3 leading-snug" data-id="element-382" data-mp="1xh8ioo6xnbf9">
                    {resource.title}
                  </h2>
                  <p className="text-midnight-navy/50 leading-relaxed mb-6" data-id="element-383" data-mp="1sg2mgge2d60z">
                    {resource.description}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-midnight-navy font-bold text-sm group-hover:text-royal-blue transition-colors" data-id="element-384" data-mp="2l61iivqoe3f5">
                    Read more
                    <ArrowUpRightIcon className="w-4 h-4" data-id="element-385" data-mp="2b8dl1y1oqhta" />
                  </span>
                </motion.article>;
          })}
          </div>
        </div>
      </section>

      <CTASection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-386" data-mp="zthzds4mfg38" />
      <Footer data-id="element-387" data-mp="zv1c58r2j909" />
      <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} data-id="element-388" data-mp="zrdm4jku14qa" />
    </motion.main>;
}